<template>
  <div>
    <h3 class="title">Medical Analysis</h3>
    <abstractTable
      :columns="medicalAnalysisColumns"
      :data="apiMedicalAnaylsis()"
      :classes="'ui very compact left aligned celled table'"
      :dataPerPage="15"
      :paginationEnable="true"
      :paginationNextButtonText="$t('next')"
      :paginationPervButtonText="$t('previous')"
      :paginationFirstPageButtonText="$t('first')"
      :paginationLastPageButtonText="$t('last')"
      :useLongTextStyle="false"
      v-if="apiMedicalAnaylsis().length"
    />

    <p v-else>
      No medical tests has been added yet
    </p>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable')
      .default
  },
  props: {
    medicalAnalysis: { type: Array, default: () => [] }
  },
  computed: {
    medicalAnalysisColumns() {
      return [
        { header: 'Name', fieldName: 'name', show: true, width: '20%' },
        { header: 'Result', fieldName: 'result', show: true },
        { header: 'Added At', fieldName: 'createdAt', show: true, width: '15%' }
      ];
    }
  },
  methods: {
    apiMedicalAnaylsis() {
      let formalatedMedicalAnalysis = [];

      window._.each(this.medicalAnalysis, medicalAnalyses => {
        formalatedMedicalAnalysis.push({
          name: medicalAnalyses.name,
          result: medicalAnalyses.result,
          createdAt: this.timeFormat(medicalAnalyses.created_at)
        });
      });

      return formalatedMedicalAnalysis;
    },
    timeFormat(time) {
      return window.moment(time).format('LLLL');
    }
  }
};
</script>

<style scoped>
.title {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/patients/patient_log_componenets/visit_history_components/VisitAnalysis.vue